module.exports = __webpack_public_path__ + "static/introElementor-f6ac1fb8b6e454596a7e1f67d18f9182.png";